import { render, staticRenderFns } from "./GravarClienteDialog.vue?vue&type=template&id=cb22fe48&"
import script from "./GravarClienteDialog.vue?vue&type=script&lang=js&"
export * from "./GravarClienteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports